/*
 * Fraunhofer Institute for Computer Graphics Research (IGD)
 * Competence Center for Information Visualization and Visual Analytics
 *
 * Copyright (c) 2018 Fraunhofer IGD. All rights reserved.
 *
 * This source code is property of the Fraunhofer IGD and underlies
 * copyright restrictions. It may only be used with explicit
 * permission from the respective owner.
 *
 */

import {WebsocketActionTypes} from './types';
import {Dispatch} from 'redux';
import {action} from "@iva/store-utils";
import {BgpDataActionTypes} from "../bgpData/types";
import {Feature} from "geojson";
import {ASRankActionTypes} from "../asRankData/types";
import {CollectorData} from "@pages/BGPDashboard/models/CollectorData";


export function setSessionId(sessionId:string): any{
    return (dispatch: Dispatch) => {
        dispatch(action(WebsocketActionTypes.SET_SESSION_ID, sessionId));
    }
}

export function setPrefixRequest(prefixRequest : any): any{
  return (dispatch: Dispatch) => {
    dispatch(action(WebsocketActionTypes.SET_PREFIX_REQUEST, prefixRequest));
  }
}

export function registerPrefixData(data:Feature): any{
  return (dispatch: Dispatch) => {
    dispatch(action(BgpDataActionTypes.FETCH_PREFIX_DATA_SUCCESS, data));
  }
}

export function registerPrefixDataBatch(data: Array<Feature>): any{
  return (dispatch: Dispatch) => {
    dispatch(action(BgpDataActionTypes.FETCH_PREFIX_DATA_BATCH_SUCCESS, data));
  }
}

export function registerPrefixDataFinish(): any{
  return (dispatch: Dispatch) => {
    dispatch(action(BgpDataActionTypes.FETCH_PREFIX_DATA_FINISH, true));
  }
}

export function registerASRankData(data : any): any{
  return (dispatch: Dispatch) => {
    dispatch(action(ASRankActionTypes.FETCH_ASRANK_DATA_SUCCESS, data));
  }
}

export function registerCollectorData(data : Array<CollectorData>): any{
  return (dispatch: Dispatch) => {
    dispatch(action(BgpDataActionTypes.FETCH_COLLECTOR_DATA_SUCCESS, data));
  }
}

//data raw add
export function registerRawData(data: any): any{
  return (dispatch: Dispatch) => {
    dispatch(action(BgpDataActionTypes.FETCH_RAW_DATA_SUCCESS, data));
  }
}

export function registerRawDataBatch(data: any): any{
  return (dispatch: Dispatch) => {
    dispatch(action(BgpDataActionTypes.FETCH_RAW_DATA_BATCH_SUCCESS, data));
  }
}

export function registerRawDataFinish(): any{
  return (dispatch: Dispatch) => {
    dispatch(action(BgpDataActionTypes.FETCH_RAW_DATA_FINISH, true));
  }
}

export function registerPrefixDataProgress(data: any): any {
  return (dispatch: Dispatch) => {
    dispatch(action(BgpDataActionTypes.FETCH_PREFIX_DATA_PROGRESS, data));
  }
}








